import { useForm, type UseFormReturn } from 'react-hook-form';
import type { EditCryptoAddressFormValues } from './types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { editCryptoAddressFormSchema } from './validation';
import type { SavedCryptoAddress } from '@/entities/crypto-address';

type Props = {
  savedCryptoAddress: SavedCryptoAddress;
};

type Params = {
  form: UseFormReturn<EditCryptoAddressFormValues>;
};

export const useEditCryptoAddressForm = ({
  savedCryptoAddress,
}: Props): Params => {
  const { t } = useTranslation();

  const schema = editCryptoAddressFormSchema(t);

  const form = useForm<EditCryptoAddressFormValues>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      networkName: savedCryptoAddress.networkName,
      cryptoAddress: savedCryptoAddress.cryptoAddress,
      templateName: savedCryptoAddress.templateName,
    },
  });

  return {
    form,
  };
};
